import { html, render } from 'lit-html'
import { register } from '@polleverywhere/hmr-custom-element'
import { defineElementSlot } from '@polleverywhere/element-helpers'
import './style.scss'

function renderTemplate () {
  if (!this.isConnected) return

  render(html`
    <section>
      <div name='content-wrapper'>
        ${this.slots('content')[0]}
      </div>
    </section>
  `, this)
}

/**
 * Layout element with just a content slot
 * Slot is declared using a slot attribute, e.g. `<div slot='content'>`.
 *
 * @element layout-plain
 *
 * @slot content - HTML element or document fragment to insert as content
 *
 * @cssprop --background-color - Set background color
 * @cssprop --color - Set foreground color
 * @cssprop --content-height - Set a height on the content slot
 * @cssprop --content-max-width - Set a max width around the content container
 * @cssprop --content-padding - Set padding around the content container. If
 *  overridden, directional padding vars will become ineffective unless they are
 *  included as part of the value, e.g.
 *  `--content-padding: var(--content-padding-top, 1rem);`
 * @cssprop --content-padding-top - Set top padding around content.
 * @cssprop --content-padding-right - Set right padding around content.
 * @cssprop --content-padding-bottom - Set bottom padding around content.
 * @cssprop --content-padding-left - Set left padding around content.
 */
export default class LayoutPlain extends HTMLElement {
  static get tagName () {
    return 'layout-plain'
  }

  connectedCallback () {
    defineElementSlot(this, 'content')

    renderTemplate.call(this)
  }

  attributeChangedCallback () {
    renderTemplate.call(this)
  }
}

register(module, LayoutPlain.tagName, LayoutPlain)
